export default __webpack_public_path__ + "static/media/vodafone.deb7f3fa.png";